import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';
import uiReducer from 'Slices/uiSlice';
import segmentosReducer from 'Slices/Segmento/segmentoSlice';
import responseReducer from 'Slices/Response/responseSlice';
import distribucionReducer from 'Slices/Distribucion/distribucionSlice';
import rolReducer from 'Slices/Rol/rolSlice';
import usuarioReducer from 'Slices/Usuario/usuarioSlice';
import byteReducer from 'Slices/Byte/byteSlice';
import configSlice from 'Slices/Config/configSlice';
import delegacionReducer from 'Slices/Delegacion/delegacionSlice';
import capacitacionReducer from 'Slices/Capacitacion/capacitacionSlice';
import permisoReducer from 'Slices/Permisos/permisosSlice';
import idiomaReducer from 'Slices/Idioma/idiomaSlice';
import categoriaReducer from 'Slices/Categoria/categoriaSlice';
import subpilarReducer from 'Slices/Subpilar/subPilarSlice';
import cursoReducer from 'Slices/Curso/cursoSlice';
import fileReducer from 'Slices/File/fileSlice';
import palabraClaveReducer from 'Slices/PalabrasClave/palabraClaveSlice';
import nivelReducer from 'Slices/NivelSatisfaccion/nivelSlice';
import reporteReducer from 'Slices/Report/reporteSlice';
import authReducer from 'Slices/Login/loginSlice';
import casosEspecialesReducer from 'Slices/CasosEspeciales/casosEspecialesSlice';
import renapReducer from 'Slices/Renap/renapSlice';
import parametrosReducer from 'Slices/Parametros/parametroSlice';
import escolaridadReducer from 'Slices/Escolaridad/escolaridadSlice';
import segmentosEducativosReducer from 'Slices/SegmentoEducativo/segmentoEducativoSlice';
import productosReducer from 'Slices/Producto/productoSlice';
import microaprendizajeReducer from 'Slices/Microaprendizaje/microaprendizajeSlice';
import metodologiaEducativaReducer from 'Slices/MetodologiaEducativa/metodologiaEducativaSlice';
import encuestaReducer from 'Slices/Encuesta/encuestaSlice';
import campaniaReducer from 'Slices/Campania/campaniaSlice';
import dificultadReducer from 'Slices/Dificultad/dificultadSlice';
import tipoAprendizajeReducer from 'Slices/TipoAprendizaje/tipoAprendizajeSlice';
import PaquetesCursosReducer from 'Slices/PaqueteCursos/paqueteCursosSlice';
import tutorialReducer from 'Slices/Tutorial/tutorialSlice';
import busquedaReducer from 'Slices/Busqueda/busquedaSlice';
import notificacionesPlantillasReducer from 'Slices/NotificacionesPlantillas/notificacionesPlantillasSlice';
import notificacionesReducer from 'Slices/Notificaciones/notificacionesSlice';
import notificacionesUsuarioReducer from 'Slices/NotificacionesUsuario/notificacionesUsuarioSlice';
import metaReducer from 'Slices/Meta/metaSlice';
import bloqueoReducer from 'Slices/Bloqueos/bloqueoSlice'
import capacitacionesPresencialesReducer from "Slices/CapacitacionesPresenciales/capacitacionesPresencialesSlice";
import participantesReducer from "Slices/Participantes/participantesSlice";
import referidosReducer from "Slices/Referidos/referidosSlice";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  config: persistReducer(persistConfig, configSlice),
  ui: uiReducer,
  busqueda: busquedaReducer,
  response: responseReducer,
  segmentos: segmentosReducer,
  distribucion: distribucionReducer,
  rol: rolReducer,
  usuario: usuarioReducer,
  idioma: idiomaReducer,
  categoria: categoriaReducer,
  etiqueta: palabraClaveReducer,
  curso: cursoReducer,
  satisfaccion: nivelReducer,
  byte: byteReducer,
  delegacion: delegacionReducer,
  capacitacion: capacitacionReducer,
  permiso: permisoReducer,
  file: fileReducer,
  reporte: reporteReducer,
  casosEspeciales: casosEspecialesReducer,
  renap: renapReducer,
  parametros: parametrosReducer,
  escolaridad: escolaridadReducer,
  segmentoEducativo: segmentosEducativosReducer,
  producto: productosReducer,
  microaprendizaje: microaprendizajeReducer,
  metodologiaEducativa: metodologiaEducativaReducer,
  encuesta: encuestaReducer,
  campania: campaniaReducer,
  dificultad: dificultadReducer,
  tipoAprendizaje: tipoAprendizajeReducer,
  paqueteCursos: PaquetesCursosReducer,
  tutorial: tutorialReducer,
  subpilar: subpilarReducer,
  meta: metaReducer,
  notificacionesPlantillas: notificacionesPlantillasReducer,
  notificaciones: notificacionesReducer,
  notificacionesUsuario: notificacionesUsuarioReducer,
  bloqueosCampania: bloqueoReducer,
  capacitacionesPresenciales: capacitacionesPresencialesReducer,
  participantes: participantesReducer,
  referidos: referidosReducer,
});

export default rootReducer;
